import { Divider } from 'primereact/divider';
import { Fieldset } from 'primereact/fieldset';
import { useDispatch, useSelector } from "react-redux";

import moment from 'moment';
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { AppDispatch } from '../../../../store';
import { retrieveApplication } from '../ApplicationAction';
import { InterviewDTO } from "../interface";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Chip } from 'primereact/chip';
import { Tag } from 'primereact/tag';
import { downloadResumeForAdmin } from '../../Resume/ResumeAction';

interface ApplicationViewProps {
}

const ApplicationView = (props: ApplicationViewProps) => {
  const {  } = props
  const { applicationId } = useParams<{ applicationId: string }>()

  const dispatch = useDispatch<AppDispatch>()
  const { application } = useSelector((state: any) => state.application)

  useEffect(() => {
    init()
  }, [])

  const init = () => {
    dispatch(retrieveApplication(Number(applicationId)))
  }

  const handleDownloadResume = (e: any) => {
    dispatch(downloadResumeForAdmin(application.resume.token))
    e.preventDefault()
  }

  return (
    <div>
      {application && application.resume ?
        <Card>
          <h1>Resume Details</h1>
          <Fieldset toggleable legend={application.resume.fullName}>
            <div className="flex formgrid grid p-mb-4">
              <div className="field col-6 p-mb-3">
                <strong>Full Name:</strong> {application.resume.fullName}
              </div>
              <div className="field col-6 p-mb-3">
                <strong>Contact Number:</strong> {application.resume.contactNumber}
              </div>
              <div className="field col-6 p-mb-3">
                <strong>E-Mail:</strong> {application.resume.email}
              </div>
              <div className="field col-6 p-mb-3">
                <strong>Gender:</strong> {application.resume.gender}
              </div>
              <div className="field col-6 p-mb-3">
                <strong>Date of Birth:</strong> {application.resume.dateOfBirth?.toString().substring(0, 10)}
              </div>
              <div className="field col-6 p-mb-3">
                <strong>Nationality:</strong> {application.resume.nationality}
              </div>
              <div className="field col-6 p-mb-3">
                <strong>Residence:</strong> {application.resume.residence}
              </div>
              <div className="field col-6 p-mb-3">
                <strong>Country:</strong> {application.resume.country}
              </div>
              <div className="field col-6 p-mb-3">
                <strong>Highest Qualification:</strong> {application.resume.highestQualification}
              </div>
              <div className="field col-6 p-mb-3">
                <strong>Current Employment Status:</strong> {application.resume.currentEmploymentStatus}
              </div>
              <div className="field col-6 p-mb-3">
                <strong>Availability:</strong> {application.resume.availStartDate?.toString().substring(0, 10)}
              </div>
              <div className="field col-6 p-mb-3">
                <strong>Current Salary:</strong> S${application.resume.currentSalary}
              </div>
              <div className="field col-6 p-mb-3">
                <strong>Expected Salary:</strong> S${application.resume.expectedSalary}
              </div>
              <div className="field col-6 p-mb-3">
                <strong>Years of Experience:</strong> {application.resume.totalYearsOfExperiences}
              </div>
              <div className="field col-6 p-mb-3">
                <strong>Skills:</strong>
                <div className="mt-2" style={{ display: 'flex', flexWrap: 'wrap' }}>
                  {application.resume.skills?.map((skill: string, index: number) => (
                    <span className="p-chip ml-1 mb-1">{skill}</span>
                  ))}
                </div>
              </div>
              <div className="field col-6 p-mb-3">
                <strong>Language Proficiency:</strong>
                {application.resume.languageProficiency?.map((language: string, index: number) => (
                  <span className="p-chip mx-1 mb-1">{language}</span>
                ))}
              </div>
              <div className="field col-12 p-mb-4">
                <strong>Education:</strong>
                <DataTable value={application.resume.education} responsiveLayout="scroll">
                  <Column field="courseTitle" header="Course Title"></Column>
                  <Column field="educationLevel" header="Education Level"></Column>
                  <Column field="institutionName" header="Institution Name"></Column>
                  <Column field="numberOfYears" header="Number of Years"></Column>
                </DataTable>
              </div>
              <div className="field col-12 p-mb-4">
                <strong>Work Experiences:</strong>
                <DataTable value={application.resume.workExperience} responsiveLayout="scroll">
                  <Column field="companyName" header="Company Name"></Column>
                  <Column field="numberOfYears" header="Number of Years"></Column>
                  <Column field="title" header="Title"></Column>
                  <Column field="roleSummary" header="Role Summary"></Column>
                  <Column
                    field="skills"
                    header="Skills"
                    body={(rowData) => (
                      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                        {rowData.skills.map((skill: string, index: number) => (
                          <span key={index} className="p-chip mx-1 mb-1">{skill}</span>
                        ))}
                      </div>
                    )}
                  ></Column>
                </DataTable>
              </div>
              <div className="field col-12 p-mb-4">
                <strong>Professional Certificates:</strong>
                <DataTable value={application.resume.professionalCertificate} responsiveLayout="scroll">
                  <Column field="title" header="Title"></Column>
                  <Column field="issuerName" header="Issuer Name"></Column>
                  <Column field="dateIssued" header="Date Issued"></Column>
                </DataTable>
              </div>
              <div className="field col-12 p-mb-4">
                <strong>Social Links:</strong>
                <DataTable value={application.resume.socialLink} responsiveLayout="scroll">
                  <Column field="name" header="Name"></Column>
                  <Column field="link" header="Link"></Column>
                </DataTable>
              </div>
            </div>
            <div>
              <Button label="Get Resume File" onClick={handleDownloadResume}></Button>
            </div>
          </Fieldset>

          <h1>Job Details</h1>
          <Fieldset toggleable legend={application.job.title}>
            <div className="flex formgrid grid">
              <div className="field col-6">
                <strong>Status:</strong> {application.job.status}
              </div>
              <div className="field col-6">
                <Link to={"/jobs/" + application.job.id}><strong>Link to Job Details</strong></Link>
              </div>
              <div className="field col-6">
                <strong>Job Specialization:</strong> {application.job.specialization}
              </div>
              <div className="field col-6">
                <strong>Skills:</strong> {application.job.skills}
              </div>
              <div className="field col-6">
                <strong>Years of Experience:</strong> {application.job.yearsOfExp}
              </div>
              <div className="field col-6">
                <strong>Requirements:</strong> {application.job.requirements}
              </div>
              <div className="field col-6">
                <strong>Contract Type:</strong> {application.job.contractType}
              </div>
              <div className="field col-6">
                <strong>Tenant ID:</strong> {application.job.tenantId}
              </div>
            </div>
          </Fieldset>

          <h1>Interview Details</h1>
          {Object.keys(application.interviews).length !== 0 ?
            application.interviews.map((interview: InterviewDTO, index: number) => {
              return (
                <div key={index.toString()}>
                  <Fieldset toggleable legend={"Interview Attempt: " + ++index}>
                    <div className="flex formgrid grid">
                      <div className="field col-6">
                        <strong>Interview ID:</strong> <Link to={"/interviews/" + interview.id}>{interview.id}</Link>
                      </div>
                      <div className="field col-6">
                        <strong>Status:</strong> {interview.status}
                      </div>
                      <div className="field col-6">
                        <strong>Start Date:</strong> {moment(interview.startDateTime).format("dddd, Do MMMM YYYY, h:mm:ss a")}
                      </div>
                      <div className="field col-6">
                        <strong>End Date:</strong> {moment(interview.endDateTime).format("dddd, Do MMMM YYYY, h:mm:ss a")}
                      </div>
                    </div>
                  </Fieldset>
                  <Divider />
                </div>
              )
            }) :
            <Fieldset toggleable legend="No Interviews">
              <div className="flex formgrid grid">
                No interviews found for this application
              </div>
            </Fieldset>
          }
        </Card>
        :
        <></>}
    </div >
  )
}

export default ApplicationView

